// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.permanent-toast-module__toast___a8t3w {
  color: var(--surface1, #fff);
  text-align: center;
  height: 50px;
  width: 100%;
  padding: 0;
  background-color: var(--green600, #2b8000);
  border: none;
}
.permanent-toast-module__toast___a8t3w:focus {
  outline: var(--focus, #2681e1) solid 2px;
  outline-offset: 3px;
  outline-offset: -4px;
}
.permanent-toast-module__toast___a8t3w:hover {
  text-decoration: underline;
}

.permanent-toast-module__toast-children___S3Y5D {
  height: 50px;
  line-height: 50px;
  font-size: 1rem;
}`, "",{"version":3,"sources":["data:;charset=utf-8,/**%20function%20to%20get%20dimensions%0A%20%20usage%20example%20to%20get%20%60tablet%60%20value%20from%20%60$page-max-widths%60%0A%20%20.class%20%7B%0A%20%20%20%20max-width:%20dim($page-max-widths,%20tablet);%0A%20%20%7D%0A%0A%20*/%0A%0A@use%20'sass:map';%0A%0A@function%20dim($prop,%20$key)%20%7B%0A%20%20@return%20map.get($prop,%20$key);%0A%7D%0A","webpack://./client/app/react-components/permanent-toast/permanent-toast.module.scss","data:;charset=utf-8,@use%20'../functions/color'%20as%20*;%0A%0A@mixin%20focus-outline($color:%20color(focus),%20$applyDirectly:%20false)%20%7B%0A%20%20@if%20$applyDirectly%20%7B%0A%20%20%20%20outline:%20$color%20solid%202px;%0A%20%20%20%20outline-offset:%203px;%0A%20%20%7D%20@else%20%7B%0A%20%20%20%20&:focus%20%7B%0A%20%20%20%20%20%20outline:%20$color%20solid%202px;%0A%20%20%20%20%20%20outline-offset:%203px;%0A%20%20%20%20%7D%0A%20%20%7D%0A%7D%0A"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,4BAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,0CAAA;EACA,YAAA;AAMF;AAJE;ECPE,wCAAA;EACA,mBAAA;EDQA,oBAAA;AAOJ;AAJE;EACE,0BAAA;AAMJ;;AAFA;EACE,YAAA;EACA,iBAAA;EACA,eAAA;AAKF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toast": `permanent-toast-module__toast___a8t3w`,
	"toast-children": `permanent-toast-module__toast-children___S3Y5D`
};
export default ___CSS_LOADER_EXPORT___;
